"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTreeSelectContainer = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
var _StyledIcon = _interopRequireDefault(require("../Icon/StyledIcon"));
var _StyledTree = require("../Tree/StyledTree");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var Container = function Container(_ref) {
  var prefixCls = _ref.prefixCls,
    children = _ref.children,
    theme = _ref.theme,
    className = _ref.className,
    showLine = _ref.showLine;
  // last classname what we need
  var prefix = prefixCls ? prefixCls : className.split(' ').pop();
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_StyledTree.TreeStyles, {
    theme: theme,
    prefixCls: "".concat(prefix, "-tree"),
    showLine: showLine
  }), children(prefix));
};
var StyledTreeSelectContainer = exports.StyledTreeSelectContainer = (0, _ykbStyledComponents.default)(Container).withConfig({
  componentId: "ykb-ui__sc-1lj5u6c-0"
})([""]);